module.exports = __webpack_public_path__ + "assets/media/three-circles.e74664f2.svg";